import { createContext } from "react";
import { ArchivedAthlete } from "types/athlete";

export const ArchivedAthletesContext = createContext<ArchivedAthlete[] | undefined>(undefined);
ArchivedAthletesContext.displayName = "ArchivedAthletesContext";
